import React from "react";
import { BlueButton } from "../../Button";
import { currency } from "../Table";
import style from "./index.css";
import Link from "next/link";

const PricingListItem = ({ name, description }) => {
  return (
    <li className="pricing-list-item __tooltip">
      <img src="/static/img/icons/checkmark-circle-outline.svg" alt="" />
      {name}
      <i className="fas fa-info-circle"></i>
      {description && <span>{description}</span>}
    </li>
  );
};

const PricingList = ({ modules }) => {
  return (
    <ul className="pricing-list">
      {modules &&
        modules.length > 0 &&
        modules.map((module, index) => (
          <PricingListItem key={module.name} {...module} />
        ))}
    </ul>
  );
};

const PricingCard = ({
  name,
  subscriptionType,
  activeSubscriptions,
  token,
  hasTrial,
  groupId,
  modules,
  isRecommended,
}) => {
  const [open, setOpen] = React.useState(false);

  const monthlySubscription =
    (subscriptionType == "PERIODIC" ||
      subscriptionType == "ONE_OFF" ||
      subscriptionType == "PER_USER") &&
    activeSubscriptions.length > 0
      ? activeSubscriptions.find((value) => value.period == "MONTHLY")
        ? activeSubscriptions.find((value) => value.period == "MONTHLY")
        : activeSubscriptions[0]
      : subscriptionType == "PER_TRANSACTION"
      ? activeSubscriptions[0]
      : null;

  return (
    <div className="pricing-card">
      <div className="pricing-card-header">
        {isRecommended && <span className="featured">POPULAR</span>}
        <div className="title">
          <p>{name}</p>
        </div>
        <div className="sub-title">
          {subscriptionType == "ONE_OFF" && <p> One Off</p>}
          {subscriptionType === "PER_TRANSACTION" && (
            <p>
              {monthlySubscription &&
                (monthlySubscription.percentageTransactionCharge
                  ? ` ${monthlySubscription.percentageTransactionCharge} % per transaction`
                  : ` ${monthlySubscription.symbol} ${monthlySubscription.fixedTransactionCharge} per transaction`)}
            </p>
          )}
          {subscriptionType !== "PER_TRANSACTION" && monthlySubscription && (
            <p>
              {monthlySubscription.price
                ? `${monthlySubscription.symbol}${currency(
                    monthlySubscription.price
                  )}`
                : 0}
            </p>
          )}
          {(subscriptionType == "PERIODIC" || subscriptionType == "PER_USER") &&
            monthlySubscription && <p>per user/{monthlySubscription.period}</p>}
          {subscriptionType == "ONE_OFF" && <p> One Off</p>}
        </div>
        {!open && (
          <button className="open-trigger" onClick={() => setOpen(true)}>
            <i className="fas fa-plus"></i>
          </button>
        )}
      </div>
      {open && (
        <div className="pricing-card-body">
          <p className="title">ALL FEATURES IN {name}</p>
          <PricingList modules={modules} />
          <div className="action-cont">
            <Link
              href={{
                pathname: "/subscribe",
                query: {
                  offer: token,
                  trial: hasTrial,
                  isBundle: groupId ? true : false,
                },
              }}
              passHref
            >
              <BlueButton>Try Now</BlueButton>
            </Link>
          </div>
          <button className="open-trigger" onClick={() => setOpen(false)}>
            Close
            <i className="fas fa-chevron-up"></i>
          </button>
        </div>
      )}
    </div>
  );
};

const MobilePricingView = ({ offers }) => {
  return (
    <>
      <div className="pricing-view">
        <p className="pricing-view-title">Pick a plan</p>
        <div className="pricing-card-list">
          {offers.map((offer, index) => (
            <PricingCard key={`${offer.name}-${index}`} {...offer} />
          ))}
        </div>
      </div>
      <style jsx>{style}</style>
    </>
  );
};

export default MobilePricingView;
